import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cms-link',
  styleUrl: 'cms-link.scss',
  shadow: true,
})
export class CmsLink {
  /*
    Set the type of the link. Append new types if needed
  */
  @Prop() type: 'text' | 'standalone' | 'standalone-inverted';

  @Prop() href: string;

  @Prop() linkTitle: string;

  @Prop() target = '_self';

  @Prop() content: string;

  @Prop() rel: 'noopener';

  @Prop() size: 'sm' | 'md' | 'lg' = 'md';

  @Prop() nowrap? = false;

  @Prop() spacing: 'default' | 'none' | 'top' | 'bottom' = 'default';

  @Prop() icon?: string;

  @Prop() tag?: string = 'a';

  render() {
    const TagType = this.tag;
    return (
      <Host
        class={{
          [this.type]: true,
          [this.size]: true,
          [`spacing-${this.spacing}`]: true,
          nowrap: this.nowrap,
        }}
      >
        <TagType
          class='link'
          href={this.href}
          title={this.linkTitle}
          target={this.target}
          innerHTML={this.content}
          rel={this.rel}
        />
        {this.icon ? (
          <cms-icon
            icon={this.icon}
            size={this.size === 'lg' ? 'md' : 'sm'}
            colorToken='--cms-link-text-color'
          />
        ) : null}
      </Host>
    );
  }
}
